import { render, staticRenderFns } from "./ordersCashIn.vue?vue&type=template&id=067d0ae8&"
import script from "./ordersCashIn.vue?vue&type=script&lang=js&"
export * from "./ordersCashIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports